import {
  BrokerOfficeListResponse,
  BrokerOfficeListParams,
  BrokerOfficeSearchLocation,
  BrokerOfficeSorting,
} from '@/entity/BrokerOffice';
import { buildLocationFromUrlParams } from '../../../utils';
import { BROKER_LOCATION_QUERY } from '../../../constants';

const readParam = (urlParams: Record<string, string>, key: string) => urlParams[key] || undefined;

const buildSearchLocation = (
  urlParams: Record<string, string>,
): BrokerOfficeSearchLocation | undefined => {
  const [location] = buildLocationFromUrlParams({
    locType: readParam(urlParams, BROKER_LOCATION_QUERY.type),
    locCode: readParam(urlParams, BROKER_LOCATION_QUERY.code),
    locName: readParam(urlParams, BROKER_LOCATION_QUERY.name),
    locPostcode: readParam(urlParams, BROKER_LOCATION_QUERY.postcode),
    town: readParam(urlParams, 'town'),
    zip: readParam(urlParams, 'zip'),
  });

  if (!location) return undefined;

  const { type, code, name } = location;
  const postcode = type === 'ZIP' ? location.postcode || code : location.postcode;

  return {
    type,
    code,
    name,
    ...(postcode ? { postcode } : {}),
  };
};

export const adapterBrokerOfficeList = (data: BrokerOfficeListResponse) => {
  return data.objects.map((office) => {
    return {
      id: String(office.id),
      name: office.name,
      address: `${office.address}${office.zip ? `, ${office.zip} ` : ''}${office.town ? `${office.town}` : ''}`,
      logo: office.logo,
      activePropertiesCount: office.activePropertiesCount,
      lastActiveDate: office.lastActiveDate,
      email: office.email,
      phone: office.phone ?? undefined,
      slug: office.slug,
      directLink: office.directLink,
    };
  });
};

export const adapterBrokerSearchParams = (
  urlParams: Record<string, string>,
  currentPage: number = 0,
  itemsPerPage: number = 6,
): BrokerOfficeListParams => {
  const urlName = urlParams.name || undefined;
  const urlSorting = urlParams.sorting as BrokerOfficeSorting | undefined;
  const location = buildSearchLocation(urlParams);

  return {
    currentPageIndex: currentPage,
    itemsPerPage,
    name: urlName,
    ...(location ? { location } : {}),
    sorting:
      urlSorting && ['OFFICE_ASC', 'OFFICE_DESC'].includes(urlSorting) ? urlSorting : undefined,
  };
};
